import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { AnalyticsEvents, Module, Platform, UserAction, View } from '@candidate/app/analytics.constants'
import { AppConfigService } from '@engineering11/tenant-bootstrap-web'
import { AnalyticsService } from '@engineering11/web-api-firebase'

@Component({
  templateUrl: './find-account.component.html',
  styleUrls: ['./find-account.component.scss'],
})
export class AuthRecoveryFindAccountComponent implements OnInit {
  logoUrl = this.appConfig.config.brand.logoImageDarkUrl
  constructor(private analyticsService: AnalyticsService, private router: Router, private appConfig: AppConfigService) {}

  ngOnInit(): void {}

  sendAnalyticsEvent() {
    this.analyticsService.logEvent(Platform.dev, {
      module: Module.authentication,
      view: View.authenticationEmailVerification,
      analyticsEvent: AnalyticsEvents.accountRecovery,
      userAction: UserAction.formSubmit,
    })
  }

  continueToLogin() {
    this.router.navigate(['profile'])
  }
}
